/* VESPER LUNA — Customer pages JS helpers
   - Password eye toggle
   - Login form tab switch (email / phone)
   - Date select (day/month/year) → hidden ISO date merge
   - Phone format + validate
   - Marketing channel checkbox group bind
*/

(function() {
  'use strict';

  // ─────────────────────────────────────
  // Eye toggle (password show/hide)
  // ─────────────────────────────────────
  function initEyeToggles() {
    document.querySelectorAll('[data-vl-eye]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var targetId = btn.getAttribute('data-vl-eye');
        var input = document.getElementById(targetId);
        if (!input) return;
        var isPwd = input.type === 'password';
        input.type = isPwd ? 'text' : 'password';
        btn.setAttribute('aria-label', isPwd ? 'Şifreyi gizle' : 'Şifreyi göster');
        btn.setAttribute('aria-pressed', isPwd ? 'true' : 'false');
        btn.classList.toggle('is-visible', isPwd);
      });
    });
  }

  // ─────────────────────────────────────
  // Login tab switch
  // ─────────────────────────────────────
  function initLoginTabs() {
    var tabs = document.querySelectorAll('[data-vl-tab]');
    if (!tabs.length) return;
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var key = tab.getAttribute('data-vl-tab');
        document.querySelectorAll('[data-vl-tab]').forEach(function(t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        document.querySelectorAll('[data-vl-tab-panel]').forEach(function(p) {
          var match = p.getAttribute('data-vl-tab-panel') === key;
          p.toggleAttribute('hidden', !match);
        });
      });
    });
  }

  // ─────────────────────────────────────
  // Date merge (day/month/year → ISO YYYY-MM-DD)
  // ─────────────────────────────────────
  function initDateMerge() {
    var groups = document.querySelectorAll('[data-vl-date-group]');
    groups.forEach(function(group) {
      var day = group.querySelector('[data-vl-date="day"]');
      var month = group.querySelector('[data-vl-date="month"]');
      var year = group.querySelector('[data-vl-date="year"]');
      var hidden = group.querySelector('[data-vl-date-hidden]');
      if (!day || !month || !year || !hidden) return;

      function update() {
        if (day.value && month.value && year.value) {
          hidden.value = year.value + '-' +
            String(month.value).padStart(2, '0') + '-' +
            String(day.value).padStart(2, '0');
        } else {
          hidden.value = '';
        }
      }
      [day, month, year].forEach(function(sel) {
        sel.addEventListener('change', update);
      });
      update();
    });
  }

  // ─────────────────────────────────────
  // Phone format (live)
  //   Input: 5XXXXXXXXX → display: 5XX XXX XX XX
  // ─────────────────────────────────────
  function initPhoneFormat() {
    document.querySelectorAll('[data-vl-phone]').forEach(function(input) {
      input.addEventListener('input', function() {
        var digits = input.value.replace(/\D/g, '');
        // Strip leading 0 or 90
        if (digits.startsWith('90')) digits = digits.slice(2);
        if (digits.startsWith('0')) digits = digits.slice(1);
        digits = digits.slice(0, 10);

        var parts = [];
        if (digits.length > 0) parts.push(digits.slice(0, 3));
        if (digits.length > 3) parts.push(digits.slice(3, 6));
        if (digits.length > 6) parts.push(digits.slice(6, 8));
        if (digits.length > 8) parts.push(digits.slice(8, 10));
        input.value = parts.join(' ');
      });

      // On submit, also normalize hidden e164 if present
      var form = input.closest('form');
      if (form) {
        form.addEventListener('submit', function() {
          var digits = input.value.replace(/\D/g, '');
          if (digits.startsWith('90')) digits = digits.slice(2);
          if (digits.startsWith('0')) digits = digits.slice(1);
          // Replace value with E.164 normalized for backend
          input.value = '+90' + digits;
        });
      }
    });
  }

  // ─────────────────────────────────────
  // Marketing master + sub-channel bind
  //   Master checkbox toggles 3 sub-channels.
  //   Sub-checks combine into hidden CSV input.
  // ─────────────────────────────────────
  function initMarketingChannels() {
    var groups = document.querySelectorAll('[data-vl-marketing-group]');
    groups.forEach(function(group) {
      var master = group.querySelector('[data-vl-marketing-master]');
      var subs = group.querySelectorAll('[data-vl-marketing-channel]');
      var hidden = group.querySelector('[data-vl-marketing-hidden]');
      if (!master || !subs.length) return;

      // Master on → enable subs (don't auto-check, let user pick)
      master.addEventListener('change', function() {
        subs.forEach(function(sub) {
          sub.disabled = !master.checked;
          if (!master.checked) sub.checked = false;
        });
        updateHidden();
      });

      // Sub change → if any, ensure master also checked
      subs.forEach(function(sub) {
        sub.disabled = !master.checked;
        sub.addEventListener('change', function() {
          var anyChecked = Array.prototype.some.call(subs, function(s) { return s.checked; });
          if (anyChecked) master.checked = true;
          updateHidden();
        });
      });

      function updateHidden() {
        if (!hidden) return;
        var values = [];
        subs.forEach(function(s) {
          if (s.checked) values.push(s.value);
        });
        hidden.value = values.join(',');
      }
      updateHidden();
    });
  }

  // ─────────────────────────────────────
  // Recover password toggle (login page)
  // ─────────────────────────────────────
  function initRecoverToggle() {
    var toggle = document.querySelector('[data-recover-toggle]');
    var block = document.querySelector('[data-recover-block]');
    if (!toggle || !block) return;
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      block.removeAttribute('hidden');
      history.replaceState(null, '', '#recover');
      block.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var emailInput = block.querySelector('input[type="email"]');
      if (emailInput) setTimeout(function() { emailInput.focus(); }, 300);
    });
    if (location.hash === '#recover' ||
        block.querySelector('.vl-customer__success, .vl-customer__error')) {
      block.removeAttribute('hidden');
    }
  }

  // ─────────────────────────────────────
  // Form-level password match validation
  //   Find pwd + confirm pair by data attrs; walk up to nearest form.
  // ─────────────────────────────────────
  function initPasswordMatch() {
    document.querySelectorAll('[data-vl-pwd-confirm]').forEach(function(confirmInput) {
      var form = confirmInput.closest('form');
      if (!form) return;
      var pwd = form.querySelector('[data-vl-pwd]');
      if (!pwd) return;
      function validate() {
        if (confirmInput.value && pwd.value !== confirmInput.value) {
          confirmInput.setCustomValidity('Şifreler eşleşmiyor');
        } else {
          confirmInput.setCustomValidity('');
        }
      }
      pwd.addEventListener('input', validate);
      confirmInput.addEventListener('input', validate);
    });
  }

  // ─────────────────────────────────────
  // Boot
  // ─────────────────────────────────────
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function() {
    initEyeToggles();
    initLoginTabs();
    initDateMerge();
    initPhoneFormat();
    initMarketingChannels();
    initRecoverToggle();
    initPasswordMatch();
  });
})();
